import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

export default class IconButton extends React.Component {
  render() {
    const { icon, color, link, size } = this.props;
    return <Button icon={icon} color={color} as={link && 'a'} href={link} size={size} />;
  }
}

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  link: PropTypes.string,
  size: PropTypes.string,
};

IconButton.defaultProps = {
  color: 'grey',
  link: '',
  size: 'medium',
};
